import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgX = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 19,
	viewBox: "0 0 16 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.17 19C1.03133 19 0.901333 18.948 0.78 18.844C0.676 18.74 0.624 18.6187 0.624 18.48C0.624 18.4107 0.632667 18.35 0.65 18.298C0.684667 18.2287 0.710667 18.1767 0.728 18.142L6.682 9.744L1.014 1.658C0.962 1.554 0.936 1.44133 0.936 1.32C0.936 1.18133 0.988 1.06 1.092 0.956C1.196 0.851999 1.31733 0.799999 1.456 0.799999H3.016C3.18933 0.799999 3.328 0.843332 3.432 0.929999C3.536 0.999332 3.63133 1.10333 3.718 1.242L8.294 7.742L12.844 1.242C12.9133 1.10333 13 0.999332 13.104 0.929999C13.2253 0.843332 13.364 0.799999 13.52 0.799999H15.002C15.1407 0.799999 15.262 0.851999 15.366 0.956C15.47 1.06 15.522 1.18133 15.522 1.32C15.522 1.44133 15.4873 1.554 15.418 1.658L9.828 9.77L15.756 18.142C15.7907 18.1767 15.8167 18.2287 15.834 18.298C15.8513 18.35 15.86 18.4107 15.86 18.48C15.86 18.6187 15.808 18.74 15.704 18.844C15.6 18.948 15.47 19 15.314 19H13.728C13.572 19 13.4333 18.9567 13.312 18.87C13.208 18.7833 13.1127 18.688 13.026 18.584L8.19 11.824L3.38 18.584C3.29333 18.688 3.198 18.7833 3.094 18.87C2.99 18.9567 2.85133 19 2.678 19H1.17Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgX);
export { ForwardRef as ReactComponent };
